import { useContext, useLayoutEffect, useRef } from "react";
import { BefRpcContext, BefPageServiceContext, BefPageControllerContext, BefGlobalContext, BefGuid, BefMessageServiceContext, BefLanguageServiceContext, BefPage, BefEntityField } from "@beflam/bef-core";
import { BefMessage } from "@beflam/bef-core";
import { Button, Dialog } from '@alifd/next';
declare var luckysheet: any;
export function Sheet(props: any) {
  const befRpc = useContext(BefRpcContext);
  const pageService = useContext(BefPageServiceContext);
  const sGlobal = useContext(BefGlobalContext);
  const pageController = useContext(BefPageControllerContext);
  const messageService = useContext(BefMessageServiceContext);
  const befLanguageService = useContext(BefLanguageServiceContext)
  const sheetObj = useRef(null);
  let displayFields: string;
  let noDisplayFields: string;
  let entitySource = props.entitySource;
  let partSchema: any;
  let appID = props.appID;
  let isShare: boolean = true;//是否分享
  let ownerIDs: string = "";//拥有者
  let shareIDs: string = "";//共享者
  let isSinglePage: boolean = props.isSinglePage;
  let commandid = "";
  let sheetName = props.entitySource;//工作表名称
  let columnFormats: any = [];
  let titleFormat = "";
  let titleText = "";
  let defSortOrder: string;  // 设置默认排序
  let sheetID = "luckysheet" + BefGuid.newGuid();
  // let pageInfo = pageService.page.appID + "_" + pageService.page.pageID + pageService.page.state;
  let pageInfo = "123";

  let allowRangeList: any[] = [];
  let sheet = 0;
  let allowEdit = true;
  let lockFirstRow = false;
  let _displayFieldsList: any[] = [];
  let columns = [];
  let cellData: any[] = [];
  let dataSource: any[] = [];
  let lang = "zh";
  let options: any = null;
  let column = 18;
  let allowShare = false;
  let fieldTexts: any;
  const refresh = () => {
    getData((data: any[]) => {

      if (sheet === 1 && cellData.length > 1) {
        cellData.splice(_displayFieldsList.length, cellData.length - 1);
      }
      for (var i = 0; i < _displayFieldsList.length; i++) {
        for (var j = 1; j <= data.length; j++) {
          cellData.push({ r: j, c: i, v: { "v": data[j - 1][_displayFieldsList[i]], "m": "center center", "ht": "0", "vt": "0" } })
        }
      }
      dataSource = data;
      if (options) {
        luckysheet.refresh({
          "celldata": cellData
        })
      }
      else {
        luckysheet.create(getOption());
        luckysheet.setHorizontalFrozen(false);
      }

    }, (error: BefMessage) => {
      messageService.showMessage(error);
    });
  }

  const getOption = () => {
    options = {
      container: sheetID,
      lang: lang,
      gridKey: pageInfo,
      allowUpdate: true,
      showtoolbarConfig: { //工具栏
        save: allowEdit,
        SelectData: false,
        UpDownData: false,
        ModifyValueMode: false,
        EngineData: false,
        CaclIds: false,
        TblConn: false,
        FieldProp: false,
        FieldModel: false,
        undoRedo: true, //撤销重做，注意撤消重做是两个按钮，由这一个配置决定显示还是隐藏
        paintFormat: true, //格式刷
        currencyFormat: true, //货币格式
        percentageFormat: true, //百分比格式
        numberDecrease: true, // '减少小数位数'
        numberIncrease: true, // '增加小数位数
        moreFormats: true, // '更多格式'
        font: true, // '字体'
        fontSize: true, // '字号大小'
        bold: true, // '粗体 (Ctrl+B)'
        italic: true, // '斜体 (Ctrl+I)'
        strikethrough: true, // '删除线 (Alt+Shift+5)'
        underline: true, // '下划线 (Alt+Shift+6)'
        textColor: true, // '文本颜色'
        fillColor: true, // '单元格颜色'
        border: true, // '边框'
        mergeCell: true, // '合并单元格'
        horizontalAlignMode: true, // '水平对齐方式'
        verticalAlignMode: true, // '垂直对齐方式'
        textWrapMode: true, // '换行方式'
        textRotateMode: false, // '文本旋转方式'
        image: false, // '插入图片'
        link: false, // '插入链接'
        chart: false, // '图表'（图标隐藏，但是如果配置了chart插件，右击仍然可以新建图表）
        postil: false, //'批注'
        pivotTable: false,  //'数据透视表'
        function: false, // '公式'
        frozenMode: false, // '冻结方式'
        sortAndFilter: false, // '排序和筛选'
        conditionalFormat: false, // '条件格式'
        dataVerification: false, // '数据验证'
        splitColumn: false, // '分列'
        screenshot: false, // '截图'
        findAndReplace: true, // '查找替换'
        protection: false, // '工作表保护'
        print: false, // '打印'
        share: allowShare,
      },
      cellRightClickConfig: { //右键菜单
        copy: true, // 复制
        copyAs: false, // 复制为
        paste: true, // 粘贴
        insertRow: true, // 插入行
        insertColumn: true, // 插入列
        deleteRow: true, // 删除选中行
        deleteColumn: true, // 删除选中列
        deleteCell: true, // 删除单元格
        hideRow: false, // 隐藏选中行和显示选中行
        hideColumn: false, // 隐藏选中列和显示选中列
        rowHeight: true, // 行高
        columnWidth: true, // 列宽
        clear: true, // 清除内容
        matrix: false, // 矩阵操作选区
        sort: true, // 排序选区
        filter: true, // 筛选选区
        chart: false, // 图表生成
        image: false, // 插入图片
        link: false, // 插入链接
        data: true, // 数据验证
        cellFormat: false // 设置单元格格式
      },
      showsheetbar: false,
      showsheetbarConfig: {
        sheet: true,
      },
      sheetRightClickConfig: {
        delete: false, // 删除
        copy: false, // 复制
        rename: false, //重命名
        color: false, //更改颜色
        hide: false, //隐藏，取消隐藏
        move: false, //向左移，向右移
      },
      showinfobar: false,
      hook: {
        onSave: function (event: any) {
          save()
        },
        onShare: function (event: any) {
          share();
        },
        onRefresh: function (event: any) {
          refresh();
        },
        cellEditBefore: function (cell: any, position: any, sheetFile: any, ctx: any) {
          if (sheet === 1 && cell.length > 0 && cell[0].row_focus === 0) {
            return false;
          }
          else if (!allowEdit) {
            return false;
          }
        },
        rangePasteBefore: function (range: any, data: any) {
          for (var i in range) {
            if (range[i].row[0] == 0) {
              return false;
            }
          }
        },

      },
      data: [
        {
          "name": sheetName, //工作表名称
          "columnFormats": columnFormats,
          "color": "", //工作表颜色
          "index": 0, //工作表索引
          "status": 1, //激活状态
          "order": 0, //工作表的下标
          "hide": 0,//是否隐藏
          "defaultRowHeight": 25, //自定义行高
          "defaultColWidth": 150, //自定义列宽
          "column": column, //列数
          "config": {
            "authority": {//当前工作表的权限配置
              selectLockedCells: 1, //选定锁定单元格
              selectunLockedCells: 1, //选定解除锁定的单元格
              formatCells: 1, //设置单元格格式
              formatColumns: 1, //设置列格式
              formatRows: 1, //设置行格式
              insertColumns: 1, //插入列
              insertRows: 1, //插入行
              insertHyperlinks: 1, //插入超链接
              deleteColumns: 1, //删除列
              deleteRows: 1, //删除行
              sort: 1, //排序
              filter: 1, //使用自动筛选
              usePivotTablereports: 1, //使用数据透视表和报表
              editObjects: 1, //编辑对象
              editScenarios: 1, //编辑方案    
              sheet: 0, //如果为1或true，则该工作表受到保护；如果为0或false，则该工作表不受保护。
              hintText: "", //弹窗提示的文字
              algorithmName: "None",//加密方案：MD2,MD4,MD5,RIPEMD-128,RIPEMD-160,SHA-1,SHA-256,SHA-384,SHA-512,WHIRLPOOL
              saltValue: null, //密码解密的盐参数，为一个自己定的随机数值
              allowRangeList: allowRangeList,
            },
          },
          "celldata": cellData,
          "lockFirstRow": lockFirstRow
        }
      ],
    }
    return options;
  }

  const popupShow = (title: string, message: string) => {
    const dialog = Dialog.notice({
      v2: true,
      title: title,
      content: message,
      footer: (
        <Button onClick={() => dialog.hide()}>
          确认
        </Button>
      )
    });
  };

  const popupError = (title: string, message: string) => {
    const dialog = Dialog.error({
      v2: true,
      title: title,
      content: message,
      footer: (
        <Button warning type="primary" onClick={() => dialog.hide()}>
          确认
        </Button>
      )
    });
  };
  const save = () => {
    updateData(GetChangedRows(), () => {
      refresh();
      popupShow("系统提示", "保存成功");
      // messageService.showMessage(new BefMessage(befLanguageService.getLanguage("framework", "SystemMessage"), befLanguageService.getLanguage("framework", "EDITSUCCESS"), ''));
    }, (error: BefMessage) => {
      popupError("系统提示", error.message);
      // messageService.showMessage(error);
    });
  }

  /**
     * 保存数据
     * @param data 
     * @param cb 
     * @param error 
     */
  const updateData = async (data: any[], cb: () => void, error: (error: BefMessage) => void) => {
    let dataAdapter = pageService.createDataAdapter("Table", entitySource);
    let deleteDatas: any[] = [];
    let updateDatas: any[] = [];
    let addDatas: any[] = [];
    data.forEach(row => {
      if (row['__ObjectState'] == "Deleting") {
        deleteDatas.push(row)
      } else if (row['__ObjectState'] == "Added") {
        addDatas.push(row)
      } else if (row['__ObjectState'] == "Modified") {
        updateDatas.push(row)
      }
    })
    await dataAdapter.save({
      addDatas: addDatas,
      updateDatas: updateDatas,
      deleteDatas: deleteDatas,
    });
    cb();
  }

  //获取改变的行
  const GetChangedRows = () => {
    let datas = [];
    let sheetData = luckysheet.getAllSheets()[0].data;
    let allRows: any[] = [];
    let primaryKeys: any[] = [];
    for (var i = 1; i < sheetData.length; i++) {

      let haskey = true;
      for (let key in partSchema?.Fields?.Items) {
        if (partSchema?.Fields?.Items[key].PrimaryKey)
          primaryKeys.push(key)
      }

      primaryKeys.forEach(key => {
        for (var j = 0; j < _displayFieldsList.length; j++) {
          if (_displayFieldsList[j] === key) {
            if (!sheetData[i][j] || !sheetData[i][j]["v"]) haskey = false;
          }
        }
      })
      if (haskey) {
        const row: any = {};
        for (var j = 0; j < _displayFieldsList.length; j++) {
          if (sheetData[i][j])
            row[_displayFieldsList[j]] = sheetData[i][j]["v"];
          else
            row[_displayFieldsList[j]] = sheetData[i][j];
        }
        allRows.push(row);
      }
    }
    for (const data of dataSource) {
      let hasDeleted = true;
      primaryKeys.forEach(key => {
        allRows.forEach(row => {
          if (row[key] === data[key])
            hasDeleted = false;
        })
      })
      if (hasDeleted) {
        data['__ObjectState'] = "Deleting";
        datas.push(data);
      }
    }
    for (const row of allRows) {
      let hasAdded = true;
      let hasUpdate = false;

      primaryKeys.forEach(key => {
        dataSource.forEach(data => {
          if (row[key] === data[key]) {
            hasAdded = false;
            _displayFieldsList.forEach(field => {
              if (!((row[field] === undefined || row[field] === null || row[field] === "") && (data[field] === undefined || data[field] === null || data[field] === "")) && row[field] !== data[field])
                hasUpdate = true;
            })
          }
        })
      })
      if (hasAdded) {
        row['__ObjectState'] = "Added";
        datas.push(row);
      }
      if (hasUpdate) {
        row['__ObjectState'] = "Modified";
        datas.push(row);
      }
    }
    return datas;
  }

  const share = () => {
    // this.partService.getSheetData().then((data:any)=> {
    //   const newPage = new BefPage(that.globalService.sysAppId, 'bfSheetShare', "DEF");
    //   newPage.width = 700;
    //   newPage.height = 500;
    //   if (data && JSON.parse(data)["shareData"]) {
    //     let shareData = JSON.parse(data)["shareData"];
    //     newPage.viewState["isShare"] = shareData.isShare;
    //     newPage.viewState['shareUsers'] = shareData.shareUsers;
    //     newPage.viewState['shareMode'] = shareData.shareMode;
    //   }
    //   else {
    //     newPage.viewState["isShare"] = true;
    //     newPage.viewState['shareUsers'] = "";
    //     newPage.viewState['shareMode'] = 0;
    //   }
    //   let url = this.globalService.config.host + "?pagemode=single&commandid=" + this.pageService.page.pageID + "%25" + this.pageService.page.state;
    //   newPage.viewState['shareURL'] = url;
    //   that.pageService.showDialog(newPage, function (data) {
    //     if (data) {
    //       that.partService.saveSheetData(data);
    //     }
    //     that.partService.doAfterAction(action.name.toLowerCase());
    //   });
    // })
  }



  /**
   * 获取数据
   * @param cb 成功回调
   * @param error 失败回调
   */
  const getData = async (cb: (data: any[]) => void, error: (error: BefMessage) => void) => {
    let dataAdapter = pageService.createDataAdapter("Table", props.entitySource);
    var gridData = await dataAdapter.list({
      queryWheres: props.queryWheres,
      data: {},
      sortOrder: props.defSortOrder
    });
    cb(gridData);
  }
  const createSheet = (_allowEdit: boolean) => {
    allowEdit = _allowEdit;
    const sdata = {
      appId: pageService.page.appID,
      entitySchemaId: props.entitySource,
    };
    befRpc.callRpc(pageService.page.appID, '', 'Beflam.Framework.Service.SchemaService', 'GetSchema', sdata).subscribe((_schemaData: any) => {
      partSchema = _schemaData

      let keys = Object.keys(_schemaData?.Fields.Items ? _schemaData?.Fields.Items : {});
      keys.forEach(key => {
        if (partSchema.Fields.Items[key].DataType == "StringType") {
          columnFormats.push({ "fa": "@" })
        }
        else {
          columnFormats.push(null);
        }
      })
      const ldata = {
        appId: pageService.page.appID,
        displayFields: keys.join(","),
        language: "zh-CN",
      };
      befRpc.callRpc(pageService.page.appID, 'Beflam.Framework.Common', 'Beflam.Framework.Common.Localization.SysLanguageTextService', 'GetFieldTexts', ldata)
        .subscribe((result: any) => {
          fieldTexts = result
          if (partSchema) {
            setColumnsFromSchema();
            if (sGlobal?.session?.lang?.toLowerCase() !== "zh-cn") {
              lang = "en";
            }
            lockFirstRow = true;
            sheet = 1;
            allowRangeList = [
              { //区域保护
                name: "area", //名称
                password: "", //密码
                hintText: "", //提示文字
                algorithmName: "None",//加密方案：MD2,MD4,MD5,RIPEMD-128,RIPEMD-160,SHA-1,SHA-256,SHA-384,SHA-512,WHIRLPOOL
                saltValue: null, //密码解密的盐参数，为一个自己定的随机数值
                sqref: "$A$2:$BH$50000" //区域范围
              }
            ]
          }
          if (entitySource) {
            refresh();
          }
          else {
            luckysheet.create(getOption());
            luckysheet.setHorizontalFrozen(false);
          }
        });
    })

  }


  const setColumnsFromSchema = () => {
    let _displayFields: any[] = [];
    let _noDisplayFields: any[] = [];


    if (displayFields) {
      _displayFields = displayFields.split(',');
    }
    if (noDisplayFields) {
      _noDisplayFields = noDisplayFields.split(',');
    }

    let allFields: any[] = [];
    let fields: any[] = [];
    for (const field in partSchema.Fields.Items) {
      allFields.push(partSchema?.Fields?.Items[field]?.Field);
    }

    if (_noDisplayFields && _noDisplayFields.length > 0) {
      displayFields = "";
      for (let field of allFields) {
        if (_noDisplayFields.indexOf(field) < 0) {
          fields.push(field);
          if (displayFields == "")
            displayFields += field;
          else
            displayFields += "," + field;
        }
      }
    } else if (_displayFields && _displayFields.length > 0) {
      for (let field of _displayFields) {
        if (allFields.indexOf(field) >= 0) {
          fields.push(field);
        }
      }
    } else {
      fields = allFields;
    }
    _displayFieldsList = fields;
    column = fields.length;
    for (var i = 0; i < fields.length; i++) {
      let field: BefEntityField = partSchema.Fields.Items[fields[i]];
      cellData.push({ r: 0, c: i, v: { bg: "#d3d3d3", "v": (fieldTexts && fieldTexts[field.Field]) ? fieldTexts[field.Field] : field.Field, "m": "center center", "ht": "0", "vt": "0" } })
    }
  }

  useLayoutEffect(() => {
    if (!sGlobal.session.id) {
      //这里使用异步调用，防止无法路有跳转问题
      setTimeout(() => {
        sGlobal.onSessionTimeout();
      }, 1);
    } else {
      pageService.page = new BefPage(appID, entitySource, "SheetShare");
      pageService.getSheetData()?.then((data: any) => {
        if (data && JSON.parse(data)["shareData"]) {
          let shareData = JSON.parse(data)["shareData"];
          ownerIDs = shareData?.ownerUser ?? "";
          // let shareMode = shareData?.shareMode ?? "1";
          // if (shareMode == "0")
          //   allowEdit = false;
          if (shareData.isShare) {
            let isOwner = false;

            ownerIDs.split(",").forEach(user => {
              if (sGlobal.session.userId === user) {
                isOwner = true;
                // allowShare = true;
              }
            });
            let isUser = false;
            shareData.shareUsers?.split(",").forEach((user: string) => {
              if (sGlobal.session.userId === user) {
                isUser = true;
              }
            });
            if (isOwner) {
              createSheet(true);
            } else if (isUser) {
              if (shareData.shareMode === "1") {
                createSheet(true);
              } else {
                createSheet(false);
              }
            } else {
              popupError("系统提示", "对不起,当前用户暂无权限浏览该页面!");
              // messageService.showMessage(new BefMessage(befLanguageService.getLanguage("framework", "SystemMessage"), "对不起,当前用户暂无权限浏览该页面!"));
              // pageService.close();
            }
          }
          else {
            let isOwner = false;
            ownerIDs.split(",").forEach(user => {
              if (sGlobal.session.userId === user) {
                isOwner = true;
                // allowShare = true;
              }
            });
            if (isOwner) {
              createSheet(true);
            } else {
              popupError("系统提示", "对不起,当前用户暂无权限浏览该页面!");
              // messageService.showMessage(new BefMessage(befLanguageService.getLanguage("framework", "SystemMessage"), "对不起,当前用户暂无权限浏览该页面!"));
              // pageService.close();
            }
          }


        } else {
          let isOwner = false;
          ownerIDs.split(",").forEach(user => {
            if (sGlobal.session.userId === user) {
              isOwner = true;
              // allowShare = true;
            }
          });

          if (isOwner) {
            createSheet(true);
          } else {
            popupError("系统提示", "对不起,当前用户暂无权限浏览该页面!");
            // messageService.showMessage(new BefMessage(befLanguageService.getLanguage("framework", "SystemMessage"), "对不起,当前用户暂无权限浏览该页面!"));
            // pageService.close();
          }
        }
      })

    }
  }
    , []);
  return (
    <>
      <div id={sheetID} style={{ width: "100%", height: "100%" }} ref={sheetObj}></div>
    </>
  );
}
